/** localStorage key used to persist the active supply point selection */
export const ACTIVE_SUPPLY_POINT_STORAGE_KEY = 'prosumo.activeSupplyPointId';
